import { z } from 'zod';

export const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const BookingInquirySchema = z
  .object({
    subject: z.string().trim().min(3).max(200),
    date_range_start: z.string().regex(ISO_DATE_PATTERN, {
      error: 'chat:booking.form.validation.startDate',
    }),
    date_range_end: z.string().regex(ISO_DATE_PATTERN, {
      error: 'chat:booking.form.validation.endDate',
    }),
    production: z.string().trim().min(1).max(200),
    compensation_range: z.string().trim().min(1).max(100),
    notes: z.string().trim().max(2_000).optional().default(''),
  })
  .refine((d) => d.date_range_end >= d.date_range_start, {
    path: ['date_range_end'],
    error: 'chat:booking.form.validation.endAfterStart',
  });
